import { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/*
 * Skeleton — DESIGN_SYSTEM.md §2.1
 * Surface-2 → line shimmer for loading placeholders.
 *
 * Usage:
 *   <Skeleton className="h-4 w-24" />
 *   <Skeleton variant="circle" className="h-10 w-10" />
 */

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'rect' | 'circle' | 'text';
}

export function Skeleton({ className, variant = 'rect', ...props }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={cn(
        'animate-pulse bg-gradient-to-r from-surface-2 via-line to-surface-2 bg-[length:200%_100%]',
        variant === 'rect' && 'rounded-md',
        variant === 'circle' && 'rounded-pill',
        variant === 'text' && 'rounded-sm h-4',
        className,
      )}
      {...props}
    />
  );
}
